import { Object3D, Quaternion, Vector3 } from "three";
import { Command } from "./Command";

export class TransformCommand implements Command {
  private _object: Object3D;
  private _transform: {
    position?: Vector3;
    rotation?: Quaternion;
    scale?: Vector3;
  };

  private _originalTransform: {
    position?: Vector3;
    rotation?: Quaternion;
    scale?: Vector3;
  };

  constructor(
    object: Object3D,
    totransform: {
      position?: Vector3;
      rotation?: Quaternion;
      scale?: Vector3;
    },
    fromtransform?: {
      position?: Vector3;
      rotation?: Quaternion;
      scale?: Vector3;
    }
  ) {
    this._object = object;
    this._originalTransform = fromtransform || {
      position: object.position.clone(),
      rotation: object.quaternion.clone(),
      scale: object.scale.clone(),
    };
    this._transform = totransform;
    this.do();
  }

  ref(): object | undefined | void {
    return this._object;
  }

  action(): void {}

  do(): void {
    if (this._transform.position)
      this._object.position.copy(this._transform.position!);
    if (this._transform.rotation)
      this._object.quaternion.copy(this._transform.rotation!);
    if (this._transform.scale) this._object.scale.copy(this._transform.scale!);
  }

  undo(): void {
    this._object.position.copy(this._originalTransform.position!);
    this._object.quaternion.copy(this._originalTransform.rotation!);
    this._object.scale.copy(this._originalTransform.scale!);
  }

  release(): void {}
}
